import { render, staticRenderFns } from "./CatalogSearch.vue?vue&type=template&id=04a34b04&"
import script from "./CatalogSearch.vue?vue&type=script&lang=ts&"
export * from "./CatalogSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports